<template>
  <div class="homecontainer _homecontainer">
    <div class="itemBox">
      <div class="title"><span class="title-icon"></span>订单查询</div>
      <div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="100px"
          label-position="top"
        >
          <el-form-item label="订单号" prop="orderNo">
            <el-input
              v-model="form.orderNo"
              placeholder="请输入订单号"
              size="mini"
            />
          </el-form-item>
          <el-form-item label="取卡密码" prop="password">
            <el-input
              v-model="form.password"
              placeholder="请输入取卡密码"
              :minlength="6"
              :maxlength="20"
              size="mini"
            >
            </el-input>
          </el-form-item>
          <div style="text-align: center;margin-top:20px">
            <el-button type="primary" @click="submitForm('form')" size="mini"
              >立即查询</el-button
            >
          </div>
        </el-form>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
    <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
    <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
    <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
  </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "",
  components: {
  },
  data() {
    return {
        activeName: 'first',
      form: {},
      goodsList: [
        {
          value: 1,
          label: "泡泡账密--1个",
        },
      ],
      payTypeList: [
        {
          value: 1,
          label: "USDT",
        },
      ],
      rules: {
        author: [{ required: true, message: "作者不能为空", trigger: "blur" }],
        type: [
          {
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        }
      });
    },
     handleClick(tab, event) {
        console.log(tab, event);
      }
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input-number .el-input__inner {
  text-align: left !important;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0px !important;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
/deep/ .el-form-item__label {
  line-height: 26px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #3b3b3b;
  line-height: 20px;
  width: 100px;
  display: inline-block;
  margin-bottom: 30px;
  .title-icon {
    border-left: 4px solid rgb(51, 51, 51);
    border-radius: 3px;
    height: 15px;
    width: 4px;
    display: inline-block;
    margin-right: 10px;
  }
}
.itemBox {
  border-radius: 20px;
  border: 1px solid #ffffff;
  background-color: #ffffff;
  padding: 20px;
  margin: 20px auto;
  width: 680px;
}
// // 大于800px
// @media only screen and (min-width: 800px){
//     .homecontainer{
//       font-size: 1vw;
//       .subdiv{
//         width: 100%;
//         display: flex;
//         justify-content: space-around;
//         font-size: .5em;
//         .left{
//           width: 48%;
//           height: 100%;
//           font-size: .8em;
//         }
//         .right{
//           width: 48%;
//           height: 100%;
//           font-size: .8em;
//         }
//       }
//     }
// }

// // 小于800px
// @media only screen and (max-width: 800px){
//     ._homecontainer{
//       font-size: 1vw;
//       ._subdiv{
//         width: 100%;
//         display: flex;
//         flex-direction: column;
//         // justify-content: space-around;
//         font-size: .5em;
//         .left{
//           width: 100%;
//           height: 100%;
//           font-size: .8em;
//         }
//         .right{
//           width: 100%;
//           height: 100%;
//           font-size: .8em;
//         }
//       }
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/SearchOrder/SearchOrder.vue